import { STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_SUCCESS } from '../constants'

export function selectImageExpertise(image) {
  return (dispatch, getState) => {
    const { stock } = getState()
    const files =
      stock.takingCarManagement.fastStockLoading.saveData.files

    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_SELECT_IMAGE_SUCCESS,
      data: Array.isArray(image)
        ? image
        : [...files, image]
    })
  }
}
